import { useState } from "react";
import { adminApi } from "../../lib/api";

export function AdminLogin() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [pending, setPending] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setPending(true);
    try {
      await adminApi.requestMagicLink(email.trim().toLowerCase());
    } finally {
      setSubmitted(true);
      setPending(false);
    }
  }

  return (
    <section className="mx-auto max-w-md px-4 py-10">
      <h1 className="text-2xl font-semibold">Admin sign-in</h1>
      <p className="mt-2 text-slate-600">
        Enter your platform-admin email. We&rsquo;ll send you a single-use
        sign-in link; it expires in 15 minutes.
      </p>
      {submitted ? (
        <p className="mt-6 rounded border border-slate-200 bg-slate-50 p-4 text-sm">
          If the email is a platform admin, a sign-in link is on its way.
          Check your inbox.
        </p>
      ) : (
        <form onSubmit={onSubmit} className="mt-6 space-y-4">
          <label className="block">
            <span className="text-sm font-medium">Email</span>
            <input
              required
              type="email"
              inputMode="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 w-full rounded border border-slate-300 px-3 py-2"
            />
          </label>
          <button
            type="submit"
            disabled={pending}
            className="rounded bg-slate-900 px-4 py-2 text-white disabled:bg-slate-400"
          >
            {pending ? "Sending\u2026" : "Send me a sign-in link"}
          </button>
        </form>
      )}
    </section>
  );
}
